import styles from "./styles/default.module.scss";
import ImageWrapper from "../../../../components/ImageWrapper/component";
import { SectionContainer } from "../SectionContainer/component";

export default function Banner({ url }) {
    if (!url) {
        return null;
    }
    return (
        <SectionContainer className={styles.banner}>
            <ImageWrapper
                url={url}
                type="host-image"
                loading={null}
                isAboveFold={true}
                className={styles.image}
            />
        </SectionContainer>
    );
}
